var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDone = function SvgDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    className: "svg-inline--fa fa-chevron-right fa-w-10",
    role: "img",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.54,-9.1109991)",
    id: "g6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.075,2.575)",
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 27.858804,11.771222 a 1.9975956,1.9975956 0 0 0 -2.823641,0.04083 L 7.8042231,29.042989 -0.1050609,21.133705 a 1.9975956,1.9975956 0 1 0 -2.8247444,2.824744 l 9.3216563,9.321657 a 1.9975956,1.9975956 0 0 0 2.8247443,0 L 27.859907,14.636793 a 1.9975956,1.9975956 0 0 0 -0.0011,-2.865571 z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/done.62030572.svg";
export { ForwardRef as ReactComponent };